import React from "react";

function EyeOpenLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
    >
      <path
        d="M10.5002 2.53662C14.9935 2.53662 18.7319 5.76995 19.516 10.0366C18.7327 14.3033 14.9935 17.5366 10.5002 17.5366C6.00688 17.5366 2.26854 14.3033 1.48438 10.0366C2.26771 5.76995 6.00688 2.53662 10.5002 2.53662ZM10.5002 15.87C12.1998 15.8696 13.8489 15.2923 15.1776 14.2326C16.5063 13.1729 17.436 11.6935 17.8144 10.0366C17.4346 8.38104 16.5043 6.90329 15.1757 5.84498C13.8471 4.78666 12.1988 4.21039 10.5002 4.21039C8.80162 4.21039 7.15328 4.78666 5.82469 5.84498C4.49609 6.90329 3.56585 8.38104 3.18604 10.0366C3.56446 11.6935 4.4941 13.1729 5.82283 14.2326C7.15155 15.2923 8.80065 15.8696 10.5002 15.87ZM10.5002 13.7866C9.50565 13.7866 8.55182 13.3915 7.84856 12.6883C7.1453 11.985 6.75021 11.0312 6.75021 10.0366C6.75021 9.04206 7.1453 8.08823 7.84856 7.38497C8.55182 6.68171 9.50565 6.28662 10.5002 6.28662C11.4948 6.28662 12.4486 6.68171 13.1519 7.38497C13.8551 8.08823 14.2502 9.04206 14.2502 10.0366C14.2502 11.0312 13.8551 11.985 13.1519 12.6883C12.4486 13.3915 11.4948 13.7866 10.5002 13.7866ZM10.5002 12.12C11.0527 12.12 11.5826 11.9005 11.9733 11.5098C12.364 11.1191 12.5835 10.5892 12.5835 10.0366C12.5835 9.48409 12.364 8.95418 11.9733 8.56348C11.5826 8.17278 11.0527 7.95329 10.5002 7.95329C9.94767 7.95329 9.41777 8.17278 9.02707 8.56348C8.63637 8.95418 8.41688 9.48409 8.41688 10.0366C8.41688 10.5892 8.63637 11.1191 9.02707 11.5098C9.41777 11.9005 9.94767 12.12 10.5002 12.12Z"
        fill="#0E0E0E"
      />
    </svg>
  );
}

export default EyeOpenLogo;
